export default __webpack_public_path__ + "static/media/Group 8623.b264c97d.png";